import { render, staticRenderFns } from "./MainInbox.vue?vue&type=template&id=693d0702&"
import script from "./MainInbox.vue?vue&type=script&lang=ts&"
export * from "./MainInbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports